import React from 'react';
import { createPictureFactory, Picture } from '@funtech-int/yango-shared';

import { Fader } from '@/shared/components/Fader/Fader';
import { useImagePreload } from '@/shared/hooks/useImagePreload';

import styles from './PromoCover.module.css';

const coverFactory = createPictureFactory({
    fallback: {
        src: '1747x982',
    },
});

interface PromoCoverProps {
    coverUrl: string | undefined;
    alt: string;
    contentKey: string;
}

export const PromoCover: React.FC<PromoCoverProps> = ({ coverUrl, alt, contentKey }) => {
    const computedSrc = coverUrl ? coverFactory({ fallbackUrl: coverUrl }).img.src : undefined;

    const preloadedSrc = useImagePreload(computedSrc || '', contentKey);

    return (
        <>
            <Fader contentKey={preloadedSrc.key} className={styles.root}>
                <Picture src={preloadedSrc.src} className={styles.image} alt={alt} />
            </Fader>
            <div className={styles.overlay} />
        </>
    );
};
